import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'apps/app1/src/environments/environment';
import BaseTokenService from 'libs/shared-lib1/src/lib/shared/baseToken.service';
import { App1MainResolverResolver } from '../../services/resolvers/app1-main-resolver.resolver';
import { ConfigService } from 'libs/shared-lib1/src/lib/shared/services/config-service.service';
import { DialogService } from 'libs/shared-lib1/src/lib/shared/services/decativateDialog/dialog.service';
import { Observable, Subject } from 'rxjs';
import { BaseUrlChangeDialogComponent } from 'libs/shared-lib1/src/lib/base-url-change-dialog/base-url-change-dialog.component';
@Component({
  selector: 'nxt-app1-home',
  templateUrl: './app1-home.component.html',
  styleUrls: ['./app1-home.component.scss'],
})
export class App1HomeComponent extends BaseUrlChangeDialogComponent implements OnInit {
  
  // showDialog = false;
  // subject = new Subject<boolean>();

  environment: string = 'local';
  //responseFromDialogIfSHouldLeave: false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private baseTokenService: BaseTokenService,
    private configService: ConfigService,
    public override dialogService: DialogService
  ) { 
    
    super(dialogService);

  }

  ngOnInit(): void {

    //the string we provide here need to match what we provide in routing
    const resolvedApp1Data: App1MainResolverResolver = this.activatedRoute.snapshot.data['resolvedDataForApp1'];

    if (this.configService && this.configService.production == false) {

      this.environment = 'production';

    }

    var userRole = this.baseTokenService.getUserRole();

  }
  
}
